import React from 'react';
import Forms from '../components/Forms';
import {styled} from '@volkswagen-onehub/components-core';
import Header from '../components/shared/Header';
import useTrans from '../hooks/use-trans';
import { ContainerMain } from '../styles/global.style';

const FormPageContainer = styled.div``;
const FormPage = () => {
  const trans = useTrans();

  return (
    <FormPageContainer>
      <Header {...trans.pages.forms.header} />
      <ContainerMain>
        <Forms />
      </ContainerMain>
    </FormPageContainer>
  );
};

export default FormPage;
